import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateSolarPriceDependents } from "./solar-price-dependents"
import type {
  SolarProposalAddersDto,
  UpdateSolarProposalAddersDto,
} from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Saves the adder selection. The answer is the adders read; an effective
 * change leaves stored pricing out of date, which the pricing reads report.
 */
export default function useUpdateSolarProposalAdders(): UseMutationResult<
  SolarProposalAddersDto,
  unknown,
  { proposalId: string; body: UpdateSolarProposalAddersDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      solarProposalService.patchAdders(proposalId, body),
    onSuccess: (adders, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.solarProposal.adders(proposalId),
        adders,
      )
      invalidateSolarPriceDependents(queryClient, proposalId, {
        except: [`header`, `savings`],
      })
    },
  })
}
